import type { JSX } from "react";

import RichText from "@/components/atoms/rich-text/rich-text";

import Styles from "./travel-eligibility-block.module.css";

function TravelEligibilitySection({
  title,
  travelEligibilityContent,
}: Readonly<{ title: string; travelEligibilityContent: string }>): JSX.Element {
  return (
    <main
      className="TravelEligibilitySection"
      data-testid="TravelEligibilitySection-test-id"
    >
      <div className="font-body-font">
        <div
          className=" font-header-font font-[700] md:text-[25px] text-[23px] 
          md:leading-[28px] leading-[26px] text-text-title  md:text-left mb-spacing-m"
        >
          {title}
        </div>
        <div className={`${Styles.list_block} `}>
          <RichText
            richText={travelEligibilityContent}
            className={`${Styles.richtext}`}
            data-testid="richText-testid"
          />
        </div>
      </div>
    </main>
  );
}

export default TravelEligibilitySection;
